import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { QueuemApp } from "./QueuemApp";
import "./index.css";
import "./styles/index.scss";

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ModalPoliticas } from "./components/modalPoliticas/ModalPoliticas";
import Layout from "./components/layout/Layout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <QueuemApp />,
  },
  {
    path: "/terms",
    element:  <Layout>
    <ModalPoliticas />
    </Layout>
  },
]);

Sentry.init({
    dsn: process.env.REACT_APP_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });


const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <RouterProvider router={router} />
);
